import { useRef, useState } from "react";
import { TraceabilityViewModel } from "../../viewmodels/traceability/TraceabilityViewModel";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import SlideOver from "../../components/slideOver/SlideOver";

import ReceivingItemInformation from "../../components/forms/production/ReceivingItemInformation";
import TraceShippingBarcode from "../../components/forms/traceability/TraceShippingBarcode";
import TraceLotNumber from "../../components/forms/traceability/TraceLotNumber";
import EmptyModal from "../../components/modals/EmptyModal";
import SelectMenu from "../../components/controls/SelectMenu";
import TraceSupplierItem from "../../components/forms/traceability/TraceSupplierItem";
import TracePackagingMaterial from "../../components/forms/traceability/TracePackagingMaterial";

const reportTypes = [
  { value: 0, label: "Manufactured product" },
  { value: 1, label: "Supplier item" },
  { value: 2, label: "Packaging FC Item" },
];

function Traceability(props) {
  const { logout } = props;
  const {
    loading,
    product,
    setProduct,
    slideOver,
    setSlideOver,
    onTraceBarcode,
    emptyModal,
    setEmptyModelOpen,
    printPackagingMaterialTraceReport,
    printManufacturedProductTraceReport,
    printSupplierItemTraceReport,
  } = TraceabilityViewModel(logout);

  const [reportType, setReportType] = useState(0);

  const searchRef = useRef();

  const handleSearch = () => {
    onTraceBarcode(searchRef.current.value, reportType);
  };

  const openReceivingItemInformation = function (assemblyItem) {
    setSlideOver({
      childComponent: (
        <ReceivingItemInformation
          receivingItem={assemblyItem}
          setOpen={setSlideOver}
        />
      ),
      open: true,
    });
  };

  const renderTraceResults = function () {
    if (reportType.value === 0) {
      switch (product.traceability_type) {
        case "shipping_barcode":
          return (
            <TraceShippingBarcode
              product={product}
              openReceivingItemInformation={openReceivingItemInformation}
              printManufacturedProductTraceReport={
                printManufacturedProductTraceReport
              }
            />
          );
        case "lot_number":
          return (
            <TraceLotNumber
              product={product}
              openReceivingItemInformation={openReceivingItemInformation}
              printManufacturedProductTraceReport={
                printManufacturedProductTraceReport
              }
            />
          );

        default:
          return null;
      }
    } else if (reportType.value === 1) {
      return (
        <TraceSupplierItem
          product={product}
          printSupplierItemTraceReport={printSupplierItemTraceReport}
        />
      );
    } else if (reportType.value === 2) {
      return (
        <TracePackagingMaterial
          product={product}
          printPackagingMaterialTraceReport={printPackagingMaterialTraceReport}
        />
      );
    }
  };

  return (
    <div>
      <div className="mt-2 lg:px-8">
        <div className="sm:flex sm:items-center px-4 py-5 card-custom">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold leading-6 text-gray-900">
              Traceability
            </h1>
            <div className="mt-5 flex rounded-md">
              <div className="relative flex items-stretch flex-grow focus-within:z-10">
                <input
                  type="search"
                  name="searchProduct"
                  id="searchProduct"
                  className="block w-full rounded-lg rounded-l-md pl-2 sm:text-sm border border-gray-300 rounded-tr-none rounded-br-none"
                  placeholder="Search by shipping barcode, lot or serial number"
                  ref={searchRef}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleSearch();
                  }}
                />
              </div>
              <button
                type="button"
                className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-1"
                onClick={() => handleSearch()}
              >
                <MagnifyingGlassIcon
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </button>
              <SelectMenu
                handleInputChange={(e) => {
                  setProduct(null);
                  setReportType(e.target.value);
                }}
                name="created_by"
                options={reportTypes}
                parentClass="ml-5 rounded-md w-48"
              />
            </div>
          </div>
        </div>
        {loading ? (
          <div className="py-4 flex items-center justify-center">
            <div className="w-full max-w-3xl text-center p-6 ">
              <svg
                className="animate-spin h-10 w-10 text-gray-600 mx-auto"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                ></path>
              </svg>
              <p className="mt-3 text-md text-gray-700">
                Loading traceability data...
              </p>
            </div>
          </div>
        ) : null}
        {product ? renderTraceResults() : null}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        customClass="max-w-3xl"
        setSlideOver={setSlideOver}
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Traceability)
);
